import React from 'react';

import {
  useArchiveAffiliate,
  useRestoreAffiliate,
  useMoveToTestAffiliate,
  useQaAffiliate,
  useAddComment,
} from '../../data';
import { Actions } from './Actions';

export const AffiliateActions = ({
  actions,
  data,
  onEdit,
  onViewLog,
  withViewLog = true,
}) => {
  const [archiveAffiliate] = useArchiveAffiliate();
  const [restoreAffiliate] = useRestoreAffiliate();
  const [moveToTestAffiliate] = useMoveToTestAffiliate();
  const [qaAffiliate] = useQaAffiliate();
  const [addComment] = useAddComment();

  const handleArchive = async () => {
    await archiveAffiliate(data);
  };

  const handleRestore = async () => {
    await restoreAffiliate(data);
  };

  const handleMoveToTest = async () => {
    await moveToTestAffiliate(data);
  };

  const handleAddComment = async () => {
    await addComment(data);
  };

  const handleQA = async () => {
    await qaAffiliate(data);
  };

  const handleEdit = () => onEdit?.(data);
  const handleViewLog = () => onViewLog?.(data);

  return (
    <Actions
      actions={actions}
      onArchive={handleArchive}
      onRestore={handleRestore}
      onMoveToTest={handleMoveToTest}
      onQA={handleQA}
      onEdit={handleEdit}
      onAddComment={handleAddComment}
      onViewLog={handleViewLog}
      withViewLog={withViewLog}
    />
  );
};

export default AffiliateActions;
